<script lang="ts" setup>
const { show: showErrorNotification } = useNotification()
const { hasCartItemErrors, errors } = useCart()
const { addToCartContext } = useAddToCart()
const route = useRoute()
const addToCartDialog = useUiDialog('add-to-cart')

const currentContext = ref<MagentoAddToCartContext | undefined>(undefined)

const cartUpsellProducts = computed(() => {
  return currentContext.value?.upsell || []
})

function closeDialog() {
  addToCartDialog.close()
}

const resetAddedToCart = () => {
  addToCartContext.value = undefined
  currentContext.value = undefined
}

watch(addToCartContext, async (newVal) => {
  if (!errors.value.length && newVal !== undefined && newVal.suppress !== true) {
    currentContext.value = newVal
    addToCartDialog.open()
  }
})

watch(errors, (newVal) => {
  if (newVal.length) {
    showErrorNotification({ type: 'error', message: newVal.join(', ') })
  }
})
watch(() => route.fullPath, () => {
  closeDialog()
})
</script>

<template>
  <UiDialog
    class="added-to-cart"
    name="add-to-cart"
    dialog-type="responsive"
    @close="resetAddedToCart"
  >
    <template #dialogHeader>
      <span
        class="dialog__title"
        v-text="$t('Added to cart')"
      />
    </template>

    <CartAddedItem
      v-if="currentContext"
      :item="currentContext.product"
      :available-options="currentContext?.configurableOptions || []"
      :added-items="currentContext?.items || []"
      class="added-to-cart__product"
    />

    <div class="added-to-cart__upsell-wrapper">
      <div
        v-if="cartUpsellProducts?.length"
        class="added-to-cart__upsell-header"
      >
        {{ $t('Complete your order') }}
      </div>
      <ul
        v-if="cartUpsellProducts?.length"
        class="added-to-cart__upsell"
      >
        <li
          v-for="(data) in cartUpsellProducts"
          :key="data"
          class="added-to-cart__upsell-item"
        >
          <CartUpsellTile
            :product="data"
            class="added-to-cart__upsell-tile"
          />
        </li>
      </ul>
    </div>

    <div
      v-if="errors"
      class="error"
    >
      <ul>
        <li
          v-for="(error, index) in errors"
          :key="index"
          class="error"
        >
          <pre> {{ error }}</pre>
        </li>
      </ul>
    </div>

    <template #dialogFooter>
      <div class="added-to-cart__product-buttons">
        <button
          class="added-to-cart__button"
          @click="closeDialog()"
        >
          <span>{{ $t('Continue shopping') }}</span>
        </button>

        <AppLink
          v-if="!hasCartItemErrors"
          to="/cart/"
          class="added-to-cart__link"
          data-testid="add-to-cart-view-cart"
        >
          <span>{{ $t('To basket') }}</span>
        </AppLink>
      </div>
    </template>
  </UiDialog>
</template>

<style>
  @import url("./Added.css");
</style>
